import { CommonModule } from '@angular/common';
import { BtCommonModule } from '@ng-cloud/badger-core/common/bt-common.module';
import { NgModule } from '@angular/core';
import { UserDetailComponent } from '@ng-cloud/badger-core/user/user-detail/user-detail.component';
import { UserFormComponent } from '@ng-cloud/badger-core/user/user-form/user-form.component';
import { UsersComponent} from '@ng-cloud/badger-core/user/users/users.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TranslationModule } from '../translation/translation.module';


@NgModule({
  imports: [
    CommonModule,
    BtCommonModule,
    NgxMatSelectSearchModule,
    TranslationModule,
  ],
  declarations: [
    UserDetailComponent,
    UserFormComponent,
    UsersComponent
  ],
  exports: [
    UserDetailComponent,
    UserFormComponent,
    UsersComponent,
  ]
})
export class BtUserModule {
}
